import styled from 'styled-components';
import { Label } from '../../../components/uielements';
import { key, palette } from 'styled-theme';

const desktopBreakpoint = key('breakpoints.desktop', '1024px');
const tabletBreakpoint = key('breakpoints.tablet', '820px');
const mobileBreakpoint = key('breakpoints.mobile', '480px');

const gap = {
  tiny: key('sizes.gap.tiny', '4px'),
  small: key('sizes.gap.small', '8px'),
  normal: key('sizes.gap.normal', '16px'),
  medium: key('sizes.gap.medium', '24px'),
  big: key('sizes.gap.big', '32px'),
};

const font = {
  small: key('sizes.font.small', '12px'),
  normal: key('sizes.font.normal', '14px'),
  medium: key('sizes.font.medium', '16px'),
};

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;

  @media (max-width: ${desktopBreakpoint}) {
    grid-template-columns: 1.2fr 1fr;
  }

  @media (max-width: ${tabletBreakpoint}) {
    grid-template-columns: 1fr;
    height: 100dvh;
  }

  @media (max-width: ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    height: 100dvh;
    width: 100%;
  }
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: 120px;

  @media (max-width: ${desktopBreakpoint}) {
    padding: ${gap.big} 64px;
  }

  @media (max-width: ${tabletBreakpoint}) {
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }
`;

export const SectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;

  @media (max-width: ${tabletBreakpoint}) {
    display: none;
  }

  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;

  @media (max-width: ${tabletBreakpoint}) {
    font-size: 1.5rem;
  }

  @media (max-width: ${mobileBreakpoint}) {
    font-size: 1.25rem;
  }
`;

export const SubHeading = styled(Label).attrs({ color: 'black' })`
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  @media (max-width: ${mobileBreakpoint}) {
    font-size: ${font.medium};
    line-height: 22px;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  gap: 1.8rem;

  @media (max-width: ${mobileBreakpoint}) {
    gap: ${gap.medium};
    flex-wrap: wrap;
  }
`;

export const LinkButton = styled.a`
  color: ${palette('text', 1)};
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Inter';
  font-size: 16px;
  text-underline-offset: 3px;

  @media (max-width: ${mobileBreakpoint}) {
    font-size: ${font.medium};
  }
`;
